import Bowser from "bowser";

export const getNativeBrowserLink = (signInRedirectPath: string) => {
  const redirectUrl = `${window.location.hostname}${signInRedirectPath}`;
  const dashboardLink = `${window.location.protocol}//${redirectUrl}`;
  const userAgent = navigator.userAgent.toLowerCase();
  const parserFromBowser = Bowser.getParser(userAgent);
  const phoneType = parserFromBowser?.getOSName();

  if (phoneType === "iOS") {
    // If is TikTok
    if (/useragent.*tiktok/i.test(userAgent)) {
      return `shortcuts://x-callback-url/run-shortcut?name=${crypto.randomUUID()}&x-error=${encodeURIComponent(redirectUrl)}`; // TikTok app link
    }
    return `x-safari-${dashboardLink}`;
  } else if (phoneType === "Android") {
    const separator = redirectUrl.includes("?") ? "&" : "?";
    return `intent://${redirectUrl}${separator}redirected=true#Intent;scheme=https;package=com.android.chrome;end`;
  }
  return dashboardLink;
};

export const isWebView = () => {
  const rules = [
    // if it says it's a webview, let's go with that
    "WebView",
    // iOS webview will be the same as safari but missing "Safari"
    "(iPhone|iPod|iPad)(?!.*Safari)",
    // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
    // Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
    "Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})",
    // old chrome android webview agent
    "Linux; U; Android",
  ];

  const webviewRegExp = new RegExp("(" + rules.join("|") + ")", "ig");
  const userAgent = navigator.userAgent.toLowerCase();
  return !!userAgent.match(webviewRegExp) || isWebViewForIphone();
};

export const isWebViewForIphone = () => {
  const ua = navigator.userAgent.toLowerCase();

  // --- TikTok iOS WebView (explicitly excluded) ---
  if (/tiktok|musically|aweme/.test(ua)) {
    return false;
  }

  // Common iOS webview check
  if (/instagram|fbav|fbios|fb_iab|line|twitter|snapchat/.test(ua)) {
    return true;
  }

  return false;
};
